import { CollectedData } from 'src/interfaces/collectedData'
import { OnboardingStatus } from 'src/constants/onboarding/enums'
import { ONBOARDING_STATUSES_WITH_DELAYED_INFO } from 'src/constants/onboarding/constants'

export function compareCollectedDataStepOrder(itemA: CollectedData, itemB: CollectedData): number {
  const configOrderA = itemA.collectDataStepConfig?.order
  const configOrderB = itemB.collectDataStepConfig?.order

  if (configOrderA != null && configOrderB != null) {
    if (configOrderA !== configOrderB) {
      return configOrderA - configOrderB
    }
  } else if (configOrderA == null && configOrderB != null) {
    return 1
  } else if (configOrderA != null && configOrderB == null) {
    return -1
  }

  if (itemA.collectDataStep.order !== itemB.collectDataStep.order) {
    return itemA.collectDataStep.order - itemB.collectDataStep.order
  }

  return 0
}

export function sortCollectedDataSteps(steps: CollectedData[]): CollectedData[] {
  const sortedSteps = [...steps]

  sortedSteps.sort((itemA, itemB) => {
    const delayedDiff =
      Number(itemA.collectDataStepConfig?.delayed ?? false) -
      Number(itemB.collectDataStepConfig?.delayed ?? false)

    if (delayedDiff !== 0) {
      return delayedDiff
    }

    return compareCollectedDataStepOrder(itemA, itemB)
  })

  return sortedSteps
}

export function getStepGroupKey(item: CollectedData): string {
  return `${item.collectDataStep.label}-${item.collectDataStep.type}`
}

export function groupContractorSteps(steps: CollectedData[]): [string, CollectedData[]][] {
  const groups = new Map<string, CollectedData[]>()

  for (const item of steps) {
    const key = getStepGroupKey(item)
    const existing = groups.get(key) ?? []

    existing.push(item)
    groups.set(key, existing)
  }

  return Array.from(groups.entries()).map(([key, items]) => {
    const sortedItems = items.sort((a, b) => {
      if (a.createdAt < b.createdAt) {
        return 1
      }

      if (a.createdAt > b.createdAt) {
        return -1
      }

      return 0
    })

    return [key, sortedItems]
  })
}

export interface GroupedStepWithDelayed {
  key: string
  items: CollectedData[]
  delayed: boolean
}

export function getGroupedStepsWithDelayedInfo(
  groupedSteps: [string, CollectedData[]][],
  collectedDataStatus: OnboardingStatus | undefined,
  firstDelayedStepIndex: number,
): GroupedStepWithDelayed[] {
  let stepIndex = 0
  const showDelayedInfo =
    collectedDataStatus != null &&
    ONBOARDING_STATUSES_WITH_DELAYED_INFO.includes(collectedDataStatus)

  return groupedSteps.map(([key, items]) => {
    const isDelayed = showDelayedInfo && firstDelayedStepIndex === stepIndex
    stepIndex += items.length

    return { key, items, delayed: isDelayed }
  })
}
